import { CustomCellRendererProps } from 'ag-grid-react'
import IdeyaTypography from '../../common/antd/ideya-typography'
import { selectThemeStyle } from '../../features/setting/setting.slice.ts'
import { useAppSelector } from '../../redux/hooks.ts'
import { selectManagementInput } from '../../redux/slices/management-input.slice.ts'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'

export const BookNameCellRenderer = (params: CustomCellRendererProps) => {
  const themeStyle = useAppSelector(selectThemeStyle)
  const managementInput = useSelector(selectManagementInput)

  if (!params || !params.data) return null
  const status = params.data.bookStatus
  const userId = params.data.userId
  const bookName = params.value
  const canSeeBookDetail = params.data.canSeeBookDetail

  const startDate = dayjs(managementInput.dateRange[0]).format('YYYY-MM-DD')
  const endDate = dayjs(managementInput.dateRange[1]).format('YYYY-MM-DD')

  if (!canSeeBookDetail || status === 'Inactive')
    return (
      <IdeyaTypography.Text
        style={{
          color: status === 'Inactive' ? themeStyle.disabledBookName : '',
        }}
      >
        {bookName}
      </IdeyaTypography.Text>
    )

  return (
    <a
      href={`/idea?userId=${encodeURIComponent(userId)}&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(
        endDate
      )}`}
      target={'_blank'}
      rel={'noopener noreferrer'}
      style={{
        color: themeStyle.bookNameLink,
        textDecoration: 'underline',
        cursor: 'pointer',
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {bookName}
    </a>
  )
}
